/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FaqsInputs */

const en_faqs = /** @type {(inputs: FaqsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

const nl_faqs = /** @type {(inputs: FaqsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ's`)
};

/**
* | output |
* | --- |
* | "FAQs" |
*
* @param {FaqsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const faqs = /** @type {((inputs?: FaqsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FaqsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_faqs(inputs)
	return en_faqs(inputs)
});